import { Box, Text } from '@chakra-ui/react';

function AdminCategory() {
  return (
    <Box bg='#f2edf3' w='100%' h='100vh'>
      <Box pl={'180px'} pt='80px'>
        <Text color={'black'}>Admin Category</Text>
      </Box>
    </Box>
  );
}

export default AdminCategory;
